<template>
  <div>
    <div class="hgroup-line" :class="game !== 'tb' && 'hgroup-line__multirow'">
      <div class="hgroup-line_wrapper">
        <div class="hgroup-line_item">
          <GameSwitcher :selected-game="game" @game-change="onGameChange"/>
        </div>
        <div class="hgroup-line_item">
          <div class="hgroup-line_inner">
            <OfferBanner>
              <span v-if="bonusBenefitValue" slot="value">{{ bonusBenefitValue }}%</span>
              {{ bonusBenefitDescription }}
            </OfferBanner>
          </div>
        </div>
        <div class="hgroup-line_item" v-if="game !== 'tb'">
          <div class="hgroup-line_inner">
            <OfferBanner>
              <span slot="value">{{ boosterBenefitValue }}</span>
              {{ boosterBenefitDescription }}
            </OfferBanner>
          </div>
        </div>
      </div>
    </div>

    <Transition name="page-transition" mode="out-in" appear>
      <!-- Custom spinner delay for transition -->
      <Spinner class="app-spinner" size="large" color="red" v-if="showSpinner" :delay="isMounted ? 200 : 400"/>
      <div v-else>
        <OffersSection :offers="actualOffers" open/>
        <OffersSection :offers="expiredOffers" inactive v-if="expiredOffers.length"/>
      </div>
    </Transition>
  </div>
</template>

<script>
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { namespace, State } from 'vuex-class'
import dayjs from 'dayjs'
import groupBy from 'lodash/groupBy'
import take from 'lodash/take'
import _get from 'lodash/get'
import { GAMES, BOOSTERS_BENEFITS_BY_GAMES, BONUS_BENEFITS_BY_GAMES } from '@/constants'
import { fixIsoDate } from '@/helpers'
import Spinner from '@/common/components/Spinner'
import GameSwitcher from '../components/GameSwitcher'
import OffersSection, { OfferBanner } from '../components/OffersSection'

const offers = namespace('offers')
const cards = namespace('cards')

@Component({ components: { OffersSection, Spinner, GameSwitcher, OfferBanner } })
class OffersView extends Vue {
  @Prop({ type: String }) game
  @State('country') currentCountry
  @offers.Action fetchOffersByGame
  @offers.State gameOffers
  @offers.State loading
  @cards.Getter firstBoundCard

  actualOffers = []
  expiredOffers = []
  isMounted = false

  created () {
    this.checkGame(this.game)
  }

  mounted () {
    this.isMounted = true
  }

  @Watch('gameOffers')
  sortOffers (offers) {
    const currentTime = new Date()
    const { actual, expired } = groupBy(offers, ({ endDate }) =>
      dayjs(fixIsoDate(endDate)).isAfter(currentTime) ? 'actual' : 'expired')

    this.actualOffers = actual || []
    this.expiredOffers = take(expired || [], 3)
  }

  @Watch('game')
  checkGame (game) {
    if (game) {
      this.fetchOffersByGame({ game })
    } else {
      this.redirectToDefaultGame()
    }
  }

  get showSpinner () {
    return !this.game || this.loading
  }

  get boosterBenefitValue () {
    // TODO default value should be null and handled in template by disigne for empty state
    return _get(BOOSTERS_BENEFITS_BY_GAMES, `${this.game}.${this.currentCountry}.value`, '')
  }

  get boosterBenefitDescription () {
    // TODO default value should be null and handled in template by disigne for empty state
    return this.$t(
      _get(BOOSTERS_BENEFITS_BY_GAMES, `${this.game}.${this.currentCountry}.description`, '')
    )
  }

  get bonusBenefitValue () {
    return _get(BONUS_BENEFITS_BY_GAMES, `${this.game}.${this.currentCountry}.value`, '')
  }

  get bonusBenefitDescription () {
    return this.$t(
      _get(BONUS_BENEFITS_BY_GAMES, `${this.game}.${this.currentCountry}.description`, '')
    )
  }

  redirectToDefaultGame () {
    const defaultGame = this.firstBoundCard && this.firstBoundCard.currentGame !== undefined
      ? this.firstBoundCard.currentGame
      : GAMES.MT // MT by default for bullet proof

    this.switchGame(defaultGame)
  }

  onGameChange (game) {
    this.switchGame(game)
    this.$analytics.trackPromotionFilter({ filterUrl: this.$route.fullPath })
  }

  switchGame (game) {
    this.$router.push({ params: { game } })
  }
}

export default OffersView
</script>

<style>

</style>
